<div class="loader-overlay" [class.overlay-hidden]="hideOverlay" [class.loader-show]="show">
  <div class="bounce-wrapper"><sd-loader></sd-loader></div>
</div>
